import React from 'react';
import { BRIGHTCOVE_ACCOUNT_ID } from '@/utils/config';

interface Props {
  videoId: string;
}

const BrightcoveEmbed = ({ videoId }: Props) => {
  return (
    <div>
      <div className="brightcove_responsive_padding relative pt-[56.25%] md:my-0 md:ml-auto md:mr-[5%]">
        <div className="brightcove_responsive_wrapper absolute left-0 top-1/2 m-0 h-full w-full translate-y-[-50%]">
          <iframe
            className="brightcove_player h-full w-full"
            src={`https://players.brightcove.net/${BRIGHTCOVE_ACCOUNT_ID}/default_default/index.html?videoId=${videoId}`}
            allowFullScreen
            allow="encrypted-media"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default BrightcoveEmbed;
